import axios from 'axios';

const RESOURCE_NAME = '/ecosystem/trackers';

export default {
    getTrackersIndex() {
        return axios.get(`${RESOURCE_NAME}/get-trackers-index`)
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getStartupsList(trackerId, data) {
        return axios.post(`${RESOURCE_NAME}/startups-list?id=${trackerId}`, data)
    },

    getStartupsListToAdd(id, search) {
        return axios.post(`${RESOURCE_NAME}/get-startups-list-to-add?id=${id}`, {search: search})
    },

    addStartups(startups, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/add-startups`, {startups: startups, trackers: trackerIds})
    },

    removeStartups(startupsIds, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/remove-startups`, {startup_ids: startupsIds, trackers: trackerIds})
    },

    removeAllStartups(trackerId) {
        return axios.post(`${RESOURCE_NAME}/remove-all-startups?id=${trackerId}`)
    },

    leave(trackerId) {
        return axios.post(`${RESOURCE_NAME}/leave?id=${trackerId}`)
    },

    getInitStartupsList() {
        return axios.get(`${RESOURCE_NAME}/get-init-startups-list`)
    },

}